module.exports = __webpack_public_path__ + "img/word_solutions.c159d513.svg";